import type { MarketplaceAvailability } from "@/types/content";
import { marketplaceAvailabilityLabels } from "@/types/content";
import "./MarketplaceAvailabilityBadge.css";

const iconFor: Record<MarketplaceAvailability, string> = {
  "available-in-pilot": "●",
  "catalogue-preview": "◇",
  "in-qualification": "◐",
  "in-active-development": "◐",
  planned: "○",
  "not-yet-installable": "○",
};

/**
 * Acquisition status — deliberately distinct from `StatusBadge`'s
 * engineering `FeatureStatus`. A listing can be technically implemented
 * (`StatusBadge` says "pilot") while still `not-yet-installable` here —
 * never collapse the two into one badge.
 */
export function MarketplaceAvailabilityBadge({
  availability,
}: {
  availability: MarketplaceAvailability;
}) {
  return (
    <span
      className={`marketplace-availability-badge marketplace-availability-badge-${availability}`}
    >
      <span aria-hidden="true">{iconFor[availability]}</span>
      {marketplaceAvailabilityLabels[availability]}
    </span>
  );
}
